export const RECENTLY_ACTIVE_WINDOW_DAYS = 7;
export const RECENTLY_ACTIVE_LIMIT = 5;

/** Ask the members API for the newest last-seen page; we then filter to 7 days and cap at 5. */
export const RECENTLY_ACTIVE_MEMBERS_URL = '/api/v2/members?limit=20&sort=-lastSeen';
